import BodyProfile from '~/components/shared-components/BodyProfile'
import { ArrowUpOutlined, FilterOutlined } from '@ant-design/icons'
import { Button, Col, Drawer, Dropdown, Pagination, Row, Spin } from 'antd'
import React, { useCallback, useEffect, useState } from 'react'
import { changeNetworkInMetamask } from '~/blockchain/metamask'
import {
  findEnNameByItemId,
  ITEM_SORT_USER,
  ITEM_SORT_USER_JA,
  SCREEN_SIZE,
} from '~/common/constants'
// import { useQueryState } from '~/common/hooks/useQueryState'
import { useTranslation } from '~/common/hooks/useTranslation'
import { useItem } from '~/views/redux/hooks/useItem'
import configs from '~/configs'
import {
  checkTransactionConfirmation,
  getBalanceOAS,
  hexToNumberString,
  toWei,
} from '~/blockchain/provider'
import {
  getContractHash,
  getTypeItem,
  ifaceContractMarketplace,
} from '~/blockchain/contract'
import secret_data_json from '~/assets/data/dataNameItem.json'
import TransactionCompletedSell from '~/components/Modals/TransactionCompletedSell'
import { ItemsCardMyAsset } from '~/components/shared-components/Card/ItemsCardMyAsset'
import { getNameItem, getNameItemV1, getNameItemV3 } from '~/helpers/ItemName'
import SellToMKPModal from '~/components/Modals/SellToMKPModal'
import { ethersWeb3Provider, providerOAS } from '~/blockchain/oas'
import { NodataMonster } from '~/components/shared-components/NoData/NodataMonster'
import { useSDK } from '@metamask/sdk-react'
import { useTheme } from '~/common/theme/redux/hooks/useTheme'
import { FilterItemsMyAssets } from '~/views/app/Items/ItemsDetail/components/FilterItemsMyAssets'
import SellToShopModal from '~/components/Modals/SellToShopModal'
import { useShop } from '~/views/redux/hooks/useShop'
import { useAccountProfile } from '~/views/redux/hooks/useAccountProfile'
import { useMediaQuery } from 'react-responsive'
import TransactionCompletedSellShop from '~/components/Modals/TransactionCompletedSellShop'
import getImageHash from '~/assets/data/ImageHash.json'
import { formatItemName } from '~/helpers/common'
import { sendOASTransaction } from '~/helpers/oasTransaction'
export const AssetsItems = () => {
  const { sdk } = useSDK()
  // const [category, setCategory] = useState(['Enhance_Item'])
  const [category, setCategory] = useState(
    JSON.parse(localStorage.getItem('ItemsMyAssets'))?.category || [],
  )
  const [effect, setEffect] = useState(
    JSON.parse(localStorage.getItem('ItemsMyAssets'))?.effect || [],
  )
  const [quality, setQuality] = useState(
    JSON.parse(localStorage.getItem('ItemsMyAssets'))?.quality || [],
  )
  const [mainSeedFilterRegeneration, setMainSeedFilterRegeneration] = useState(
    JSON.parse(localStorage.getItem('ItemsMyAssets'))
      ?.mainSeedFilterRegeneration || [],
  )
  const [pageSize, setPageSize] = useState(
    JSON.parse(localStorage.getItem('ItemsMyAssets'))?.pageSize || 10,
  )
  const [page, setPage] = useState(
    JSON.parse(localStorage.getItem('ItemsMyAssets'))?.page || 1,
  )
  const {
    actions,
    data: { allItemUser, totalItemUser, isLoading },
  } = useItem()

  // const { page, pageSize, setPage, setPageSize } = useQueryState()
  const { t } = useTranslation()
  const [sort, setSort] = useState(
    JSON.parse(localStorage.getItem('ItemsMyAssets'))?.sort ||
      ITEM_SORT_USER[0],
  )

  // const [typeSort, setTypeSort] = useState('-1')
  const [typeSort, setTypeSort] = useState(
    JSON.parse(localStorage.getItem('ItemsMyAssets'))?.typeSort || '-1',
  )
  const {
    actions: actionTheme,
    data: { user },
  } = useTheme()
  const [txHash, setTxHash] = useState()
  const [isModalOpenShop, setIsModalOpenShop] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoadingModal, setLoadingModal] = useState(false)
  const [nftActive, setNftActive] = useState()
  const [isModalSuccessOpen, setIsModalSuccessOpen] = useState(false)
  const [isModalSuccessShopOpen, setIsModalSuccessOpenShop] = useState(false)
  const [balanceOAS, setBalanceOAS] = useState(0)
  const { actions: actionsShop } = useShop()
  const { actions: actionsProfile } = useAccountProfile()

  const handleCancelShop = () => {
    setIsModalOpenShop(false)
    setLoadingModal(false)
  }

  const showModalSuccess = () => {
    if (nftActive?.quality === 'SHOP') {
      setIsModalSuccessOpenShop(true)
    } else {
      setIsModalSuccessOpen(true)
    }
  }

  const showModalSuccessShop = () => {
    setIsModalSuccessOpenShop(true)
  }

  const handleShare = () => {
    setIsModalSuccessOpen(false)
    setIsModalSuccessOpenShop(false)
    refreshData()
  }

  const handleCancelSuccess = () => {
    setIsModalSuccessOpen(false)
    setIsModalSuccessOpenShop(false)
    refreshData()
  }

  const handleCancelSuccessShop = () => {
    setIsModalSuccessOpenShop(false)
    refreshData()
  }

  const showModalSell = (box) => {
    if (box?.quality === 'SHOP') {
      setIsModalOpenShop(true)
    } else {
      setIsModalOpen(true)
    }
  }

  const handleSell = async (tokenID, price, quantity) => {
    try {
      // eslint-disable-next-line
      console.log({ tokenID, price, quantity })
      setLoadingModal(true)
      if (nftActive?.quality === 'SHOP') {
        const data = {
          address: user?.address_wallet,
          itemId: tokenID,
          amount: Number(quantity),
        }
        actionsShop.sellItemShop(data, (res) => {
          if (res?.txid) {
            setLoadingModal(false)
            handleCancelShop()
            setTxHash(res?.txid)
            showModalSuccessShop()
            actionsProfile.getAccountProfile((res) => {
              actionTheme.updateInfoUser({
                ...res?.player_info,
              })
            })
          }
        })
      } else if (localStorage.getItem('wallet') === 'OAS') {
        // const nonce = await ethersWeb3Provider
        //   .getSigner(providerOAS.accounts[0])
        //   .getTransactionCount()

        const {
          contract,
          iface,
          address: addressContract,
        } = getTypeItem(nftActive?.type)

        let allowance = await contract.isApprovedForAll(
          user.address_wallet,
          configs.ADDRESS_MARKETPLACE,
        )
        if (allowance) {
          sell(addressContract, tokenID, price, quantity)
        } else {
          const transactionData = {
            from: providerOAS.accounts[0],
            data: iface.encodeFunctionData('setApprovalForAll', [
              configs.ADDRESS_MARKETPLACE,
              true,
            ]),
            to: addressContract,
            // nonce: nonce,
            // gasLimit: 21000,
          }
          const transaction = await sendOASTransaction(transactionData)
          // const signedTransaction = await providerOAS.request({
          //   method: 'eth_signTransaction',
          //   params: [data],
          // })

          // const transaction = await ethersWeb3Provider.sendTransaction(
          //   String(signedTransaction),
          // )
          checkTransactionConfirmation(transaction?.hash).then((r) => {
            if (r === 'confirmed') {
              // eslint-disable-next-line
              console.log('Approve:', r, transaction?.hash)
              sell(addressContract, tokenID, price, quantity)
            }
          })
        }
      } else {
        await sdk.connect()
        await changeNetworkInMetamask(
          sdk.getProvider(),
          configs.NETWORK.chainId,
          setLoadingModal,
        )
        await sdk.connect()
        let networkId = await sdk
          .getProvider()
          .request({ method: 'eth_chainId', params: [] })
        networkId = hexToNumberString(networkId)

        if (parseInt(networkId) !== parseInt(configs.NETWORK.chainId)) return
        const {
          contract,
          iface,
          address: addressContract,
        } = getTypeItem(nftActive?.type)

        let allowance = await contract.isApprovedForAll(
          user.address_wallet,
          configs.ADDRESS_MARKETPLACE,
        )

        if (allowance) {
          sell(addressContract, tokenID, price, quantity)
        } else {
          let nonce = await sdk.getProvider().request({
            method: 'eth_getTransactionCount',
            params: [user.address_wallet, 'latest'],
          })
          sdk
            .getProvider()
            .request({
              method: 'eth_sendTransaction',
              params: [
                {
                  from: user.address_wallet,
                  data: iface.encodeFunctionData('setApprovalForAll', [
                    configs.ADDRESS_MARKETPLACE,
                    true,
                  ]),
                  to: addressContract,
                  nonce,
                },
              ],
            })
            .then((txHash) => {
              checkTransactionConfirmation(txHash).then((r) => {
                if (r === 'confirmed') {
                  // eslint-disable-next-line
                  console.log('Approve:', r, txHash)
                  new Promise((resolve) => setTimeout(resolve, 3000))
                    .then(() => {
                      sell(addressContract, tokenID, price, quantity)
                    });                
                }
              })
            })
            .catch((error) => {
              setLoadingModal(false)
              // eslint-disable-next-line
              console.error(error)
            })
        }
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
      setLoadingModal(false)
    }
  }
  const handleSellRegenHash = async (tokenID, price, quantity = 1) => {
    try {
      setLoadingModal(true)
      if (localStorage.getItem('wallet') === 'OAS') {
        // const nonce = await ethersWeb3Provider
        //   .getSigner(providerOAS.accounts[0])
        //   .getTransactionCount()

        const {
          contract,
          iface,
          address: addressContract,
        } = getContractHash(nftActive?.contractAddress)

        let checkAllow
        if (nftActive?.type === 'Regeneration_Hash') {
          checkAllow = await contract.isApprovedForAll(
            user.address_wallet,
            configs.ADDRESS_MARKETPLACE,
          )
        } else {
          let allowanceHash = await contract.getApproved(tokenID)
          checkAllow =
            allowanceHash.toLowerCase() ===
            configs.ADDRESS_MARKETPLACE.toLowerCase()
        }
        if (checkAllow) {
          sell(tokenID, price, quantity, addressContract)
        } else {
          const transactionData = {
            from: providerOAS.accounts[0],
            data:
              nftActive?.type === 'Regeneration_Hash'
                ? iface.encodeFunctionData('setApprovalForAll', [
                    configs.ADDRESS_MARKETPLACE,
                    true,
                  ])
                : iface.encodeFunctionData('approve', [
                    configs.ADDRESS_MARKETPLACE,
                    tokenID,
                  ]),
            to: addressContract,
            // nonce: nonce,
            // gasLimit: 21000,
          }
          const transaction = await sendOASTransaction(transactionData)
          // const signedTransaction = await providerOAS.request({
          //   method: 'eth_signTransaction',
          //   params: [data],
          // })

          // const transaction = await ethersWeb3Provider.sendTransaction(
          //   String(signedTransaction),
          // )
          checkTransactionConfirmation(transaction?.hash).then((r) => {
            if (r === 'confirmed') {
              // eslint-disable-next-line
              console.log('Approve:', r, transaction?.hash)
              sell(tokenID, price, quantity, addressContract)
            }
          })
        }
      } else {
        await sdk.connect()
        await changeNetworkInMetamask(
          sdk.getProvider(),
          configs.NETWORK.chainId,
          setLoadingModal,
        )
        await sdk.connect()
        let networkId = await sdk
          .getProvider()
          .request({ method: 'eth_chainId', params: [] })
        networkId = hexToNumberString(networkId)

        if (parseInt(networkId) !== parseInt(configs.NETWORK.chainId)) return

        const {
          contract,
          iface,
          address: addressContract,
        } = getContractHash(nftActive?.contractAddress)
        // eslint-disable-next-line
        console.log(contract)

        let checkAllow
        if (nftActive?.type === 'Regeneration_Hash') {
          checkAllow = await contract.isApprovedForAll(
            user.address_wallet,
            configs.ADDRESS_MARKETPLACE,
          )
        } else {
          let allowanceHash = await contract.getApproved(tokenID)
          checkAllow =
            allowanceHash.toLowerCase() ===
            configs.ADDRESS_MARKETPLACE.toLowerCase()
        }

        if (checkAllow) {
          sell(addressContract, tokenID, price, quantity)
        } else {
          let nonce = await sdk.getProvider().request({
            method: 'eth_getTransactionCount',
            params: [user.address_wallet, 'latest'],
          })
          sdk
            .getProvider()
            .request({
              method: 'eth_sendTransaction',
              params: [
                {
                  from: user.address_wallet,
                  data:
                    nftActive?.type === 'Regeneration_Hash'
                      ? iface.encodeFunctionData('setApprovalForAll', [
                          configs.ADDRESS_MARKETPLACE,
                          true,
                        ])
                      : iface.encodeFunctionData('approve', [
                          configs.ADDRESS_MARKETPLACE,
                          tokenID,
                        ]),
                  to: addressContract,
                  nonce,
                },
              ],
            })
            .then((txHash) => {
              checkTransactionConfirmation(txHash).then((r) => {
                if (r === 'confirmed') {
                  // eslint-disable-next-line
                  console.log('Approve:', r, txHash)
                  new Promise((resolve) => setTimeout(resolve, 3000))
                    .then(() => {
                      sell(addressContract, tokenID, price, quantity)
                    });
                }
              })
            })
            .catch((error) => {
              setLoadingModal(false)
              // eslint-disable-next-line
              console.error(error)
            })
        }
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
      setLoadingModal(false)
    }
  }
  const sell = async (contractAddress, tokenID, price, quantity) => {
    try {
      if (localStorage.getItem('wallet') === 'OAS') {
        // const nonce = await ethersWeb3Provider
        //   .getSigner(providerOAS.accounts[0])
        //   .getTransactionCount()

        const transactionData = {
          from: providerOAS.accounts[0],
          data: ifaceContractMarketplace.encodeFunctionData(
            'createMarketItemSale',
            [contractAddress, tokenID, toWei(price * quantity), quantity],
          ),
          to: configs.ADDRESS_MARKETPLACE,
          // nonce: nonce,
          // gasLimit: 21000,
        }
        const transaction = await sendOASTransaction(transactionData)
        // const signedTransaction = await providerOAS.request({
        //   method: 'eth_signTransaction',
        //   params: [data],
        // })

        // const transaction = await ethersWeb3Provider.sendTransaction(
        //   String(signedTransaction),
        // )
        checkTransactionConfirmation(transaction?.hash).then((r) => {
          if (r === 'confirmed') {
            // eslint-disable-next-line
            console.log(r, transaction?.hash)
            setLoadingModal(false)
            handleCancel()
            setTxHash(transaction?.hash)
            showModalSuccess()
          }
        })
      } else {
        let nonce = await sdk.getProvider().request({
          method: 'eth_getTransactionCount',
          params: [user.address_wallet, 'latest'],
        })
        sdk
          .getProvider()
          .request({
            method: 'eth_sendTransaction',
            params: [
              {
                from: user.address_wallet,
                data: ifaceContractMarketplace.encodeFunctionData(
                  'createMarketItemSale',
                  [contractAddress, tokenID, toWei(price * quantity), quantity],
                ),
                to: configs.ADDRESS_MARKETPLACE,
                nonce,
              },
            ],
          })
          .then((txHash) => {
            checkTransactionConfirmation(txHash).then((r) => {
              if (r === 'confirmed') {
                // eslint-disable-next-line
                console.log(r, txHash)
                setLoadingModal(false)
                handleCancel()
                setTxHash(txHash)
                showModalSuccess()
              }
            })
          })
          .catch((error) => {
            setLoadingModal(false)
            // eslint-disable-next-line
            console.error(error)
          })
      }
    } catch (error) {
      // eslint-disable-next-line
      console.error(error)
      setLoadingModal(false)
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setLoadingModal(false)
  }

  //Refresh data
  const refreshData = useCallback(() => {
    const params = {
      page,
      pageSize: pageSize,
      wallet_address: user.address_wallet,
      sort_by_field: sort.value,
      sort_by_dir: typeSort,
      category: category,
      effect: effect,
      quality: quality,
      main_seed: mainSeedFilterRegeneration,
    }
    actions.getAllItemUser(params)
  }, [
    page,
    pageSize,
    sort,
    typeSort,
    category,
    effect,
    quality,
    mainSeedFilterRegeneration,
  ])

  const loadBalanceOAS = () => {
    getBalanceOAS(user.address_wallet).then((res) => {
      setBalanceOAS(res)
    })
  }

  useEffect(() => {
    if (user) {
      refreshData()
      loadBalanceOAS()
    }
  }, [
    page,
    pageSize,
    sort,
    typeSort,
    category,
    effect,
    quality,
    mainSeedFilterRegeneration,
  ])

  const handleChangeSort = (e) => {
    setSort(ITEM_SORT_USER[e.key])
  }

  const handleChangeTypeSort = () => {
    if (typeSort === '-1') {
      setTypeSort('1')
    } else if (typeSort === '1') {
      setTypeSort('-1')
    }
  }

  const onChangePage = (page) => {
    setPage(page)
  }
  const onChangePageSize = (current, size) => {
    setPageSize(size)
  }
  const isMobile = useMediaQuery({ query: SCREEN_SIZE.TABLET })
  const [openFilterItem, setOpenFilterItem] = useState(false)
  const showDrawer = () => {
    setOpenFilterItem(true)
  }

  const onClose = () => {
    setOpenFilterItem(false)
  }
  const clearAll = () => {
    // setCategory(['Enhance_Item'])
    setCategory([])
    setEffect([])
    setQuality([])
  }
  useEffect(() => {
    if (page > 1) {
      onChangePage(1)
    }
  }, [
    txHash,
    pageSize,
    sort,
    typeSort,
    category,
    effect,
    quality,
    mainSeedFilterRegeneration,
  ])
  const pageFilter = JSON.parse(localStorage.getItem('ItemsMyAssets'))?.page
  useEffect(() => {
    if (pageFilter > 1) {
      setPage(pageFilter)
    }
  }, [pageFilter])
  function getItemGraphic(itemId) {
    // Kiểm tra điều kiện đặc biệt trước khi xử lý
    if (itemId === 'UPA 1912') {
      // eslint-disable-next-line
      itemId = 'UPA_1912'
    }
    if (itemId === 'UPA Gorem') {
      // eslint-disable-next-line
      itemId = 'UPA_Gorem'
    }
    if (itemId === 'UPA AC') {
      // eslint-disable-next-line
      itemId = 'UPA_AC'
    }
    if (itemId === 'UPA ODEN') {
      // eslint-disable-next-line
      itemId = 'UPA_ODEN'
    }
    if (itemId === 'UPA Ossan') {
      // eslint-disable-next-line
      itemId = 'UPA_Ossan'
    }
    if (itemId === 'UPA Villain') {
      // eslint-disable-next-line
      itemId = 'UPA_Villain'
    }
    if (itemId === 'Yamato T Shirt') {
      // eslint-disable-next-line
      itemId = 'YamatoT_Shirt'
    }
    if (itemId === 'Sound Horse') {
      // eslint-disable-next-line
      itemId = 'Soundhorse'
    }

    // Loại bỏ khoảng trắng
    let formattedItemId = itemId?.replace(/\s+/g, '')

    for (let i = 0; i < getImageHash.length; i++) {
      let formattedImageHashItemId = getImageHash[i].itemId.replace(/\s+/g, '')

      if (formattedImageHashItemId === formattedItemId) {
        return getImageHash[i].itemGraphic
      }
    }
    return null
  }

  return (
    <BodyProfile>
      <Row className={`${isMobile ? '' : 'mx-auto h-[100vh] filter_profile'}`}>
        <Col xl={6} md={6} sm={24} xs={24} className="relative">
          {isMobile ? (
            <></>
          ) : (
            <div className="flex w-full h-full">
              <FilterItemsMyAssets
                sort={sort}
                typeSort={typeSort}
                page={page}
                pageSize={pageSize}
                category={category}
                effect={effect}
                quality={quality}
                mainSeedFilterRegeneration={mainSeedFilterRegeneration}
                setCategory={setCategory}
                setEffect={setEffect}
                setQuality={setQuality}
                setMainSeedFilterRegeneration={setMainSeedFilterRegeneration}
                classCustom="filter__profile"
              />
            </div>
          )}
        </Col>
        <Col xl={18} md={18} sm={24} xs={24} className="relative">
          <div className="mx-auto z-10 pl-0  relative md:sticky top-0 sm:top-[104px]  pt-[1.5rem] pb-12">
            <div className="text-[24px] mb-4 uppercase">
              {t('profile.menu.items')}
            </div>
            <div className="flex justify-between flex-wrap mb-4">
              <div className="text-[24px]">
                {t('countItem', {
                  total: totalItemUser,
                })}
                {totalItemUser > 1 ? t('more') : ''}
              </div>
              {isMobile ? (
                <div className="flex items-center text-[16px] gap-2">
                  <Dropdown
                    className="flex items-center cursor-pointer sort__value"
                    menu={{
                      items:
                        user?.player_language === 'ja'
                          ? ITEM_SORT_USER_JA
                          : ITEM_SORT_USER,
                      selectable: true,
                      onClick: handleChangeSort,
                    }}
                    placement="bottomRight"
                    trigger={['click']}
                  >
                    <Button className="flex bg-[#0d2758] px-[10px] py-[16px] h-[44px] w-[200px]">
                      <div className="title">
                        {' '}
                        {t(`common.filter.sort.${sort.valueLanguage}`)}
                      </div>
                    </Button>
                  </Dropdown>

                  <Button
                    className="flex justify-center items-center bg-[#0d2758] px-[10px] py-[16px] h-[44px] w-[44px]"
                    onClick={() => {
                      handleChangeTypeSort()
                    }}
                  >
                    <ArrowUpOutlined
                      style={{ fontSize: 18 }}
                      rotate={typeSort === '1' ? 0 : 180}
                    />
                  </Button>
                  <div>
                    <Button
                      type="primary"
                      onClick={showDrawer}
                      className="flex justify-center items-center bg-[#0d2758] px-[10px] py-[16px] h-[44px] w-[100px]"
                    >
                      <FilterOutlined />
                      <span className="text-[13px] xl:text-[16px] md:text-[16px]">
                        {t('filter')}
                      </span>
                    </Button>
                    <Drawer
                      title={t('filter')}
                      width={330}
                      placement="left"
                      onClose={onClose}
                      open={openFilterItem}
                      extra={
                        <div
                          className="text-[16px] text-[#FAAD14] cursor-pointer"
                          onClick={() => {
                            clearAll()
                          }}
                        >
                          {t('clearAll')}
                        </div>
                      }
                    >
                      <div className="flex w-full h-full">
                        <FilterItemsMyAssets
                          sort={sort}
                          typeSort={typeSort}
                          page={page}
                          pageSize={pageSize}
                          category={category}
                          effect={effect}
                          quality={quality}
                          mainSeedFilterRegeneration={
                            mainSeedFilterRegeneration
                          }
                          setCategory={setCategory}
                          setEffect={setEffect}
                          setQuality={setQuality}
                          setMainSeedFilterRegeneration={
                            setMainSeedFilterRegeneration
                          }
                          classCustom="filter__profile"
                        />
                      </div>
                    </Drawer>
                  </div>
                </div>
              ) : (
                <div className="flex items-center text-[16px] gap-2">
                  <div> {t('sortBy')}</div>

                  <Dropdown
                    className="flex items-center cursor-pointer ml-3  sort__value"
                    menu={{
                      items:
                        user?.player_language === 'ja'
                          ? ITEM_SORT_USER_JA
                          : ITEM_SORT_USER,
                      selectable: true,
                      onClick: handleChangeSort,
                    }}
                    placement="bottomRight"
                    trigger={['click']}
                  >
                    <Button className="flex bg-[#0d2758] px-[10px] py-[16px] h-[44px] w-[200px]">
                      <div className="title">
                        {' '}
                        {t(`common.filter.sort.${sort.valueLanguage}`)}
                      </div>
                    </Button>
                  </Dropdown>

                  <Button
                    className="flex justify-center items-center bg-[#0d2758] px-[10px] py-[16px] h-[44px] w-[44px]"
                    onClick={() => {
                      handleChangeTypeSort()
                    }}
                  >
                    <ArrowUpOutlined
                      style={{ fontSize: 18 }}
                      rotate={typeSort === '1' ? 0 : 180}
                    />
                  </Button>
                </div>
              )}
            </div>

            <Spin spinning={isLoading}>
              <div className="flex flex-wrap justify-center	gap-4">
                {allItemUser?.map((data, i) => {
                  let type_id
                  switch (data?.type) {
                    case 'Traning_Item':
                      type_id = 0
                      break
                    case 'Enhance_Item':
                      type_id = 1
                      break
                    case 'Fusion_Item':
                      type_id = 2
                      break
                    case 'Regeneration_Item':
                      type_id = 3
                      break
                    default:
                      type_id = 0
                      break
                  }
                  // eslint-disable-next-line
                  data.type_id = type_id
                  // eslint-disable-next-line
                  // data.name = getNameItemV3(data?.item_type)?.name
                  return (
                    <ItemsCardMyAsset
                      t={t}
                      key={i?.toString()}
                      data={data}
                      button={{
                        title: t('sell'),
                        functionButton: () => {
                          setNftActive(data)
                          showModalSell(data)
                        },
                      }}
                      image={
                        data?.type === 'Regeneration_Hash'
                          ? getNameItem(3, data?.nft_id)?.image
                            ? data?.name === 'Regeneration Hash [Random]'
                              ? `${process.env.REACT_APP_BASE_URL_IMAGE}/public/image/image/hash/Regeneration_Hash_Random.png`
                              : `${
                                  process.env.REACT_APP_BASE_URL_IMAGE
                                }/public/image/image/items/${
                                  getNameItem(3, data?.nft_id)?.image
                                }.png`
                            : `${
                                process.env.REACT_APP_BASE_URL_IMAGE
                              }/public/image/image/hash/${getItemGraphic(
                                data?.name,
                              )}`
                          : `${
                              process.env.REACT_APP_BASE_URL_IMAGE
                            }/public/image/image/items/${
                              getNameItemV1(data?.type_id, data?.nft_id)?.image
                            }.png`
                      }
                    />
                  )
                })}
              </div>
            </Spin>
            {!isLoading && totalItemUser === 0 && <NodataMonster />}

            {totalItemUser > 0 && (
              <div className="pagination__common">
                <Pagination
                  onChange={onChangePage}
                  onShowSizeChange={onChangePageSize}
                  className="mt-5"
                  size="small"
                  locale={{ jump_to: 'Go to', page: '' }}
                  total={totalItemUser}
                  // defaultCurrent={page}
                  current={page}
                  pageSize={pageSize}
                  showSizeChanger
                  showQuickJumper
                  showTitle
                />
              </div>
            )}
            <SellToMKPModal
              action={{
                isModalOpen: isModalOpen,
                handleOk:
                  nftActive?.type === 'Regeneration_Hash'
                    ? handleSellRegenHash
                    : handleSell,
                handleCancel: handleCancel,
              }}
              tokenID={nftActive?.nft_id}
              t={t}
              loadingModal={isLoadingModal}
              // name={nftActive?.name}
              name={
                nftActive?.item_type === 'REGENERATION_HASH_OOO_R'
                  ? `Regeneration Hash [${formatItemName(nftActive?.name)}] (#${
                      nftActive?.tokenId
                    })`
                  : nftActive?.item_type === 'Enhance_Item_Crystal'
                  ? `${t('crystalItem', {
                      item: nftActive?.name,
                    })} (#${nftActive?.tokenId})`
                  : nftActive?.item_type === 'Enhance_Item_Coach'
                  ? `${nftActive?.name} (#${nftActive?.tokenId})`
                  : `${findEnNameByItemId(
                      secret_data_json,
                      nftActive?.item_type,
                      user?.player_language,
                    )} (#${nftActive?.tokenId})`
              }
              // tema={tema}
              item={nftActive}
              balance={balanceOAS}
              quanlityTotal={nftActive?.quantity}
            />
            <SellToShopModal
              action={{
                isModalOpen: isModalOpenShop,
                handleOk:
                  nftActive?.type === 'Regeneration_Hash'
                    ? handleSellRegenHash
                    : handleSell,
                handleCancel: handleCancelShop,
              }}
              tokenID={nftActive?.nft_id}
              t={t}
              loadingModal={isLoadingModal}
              // name={nftActive?.name}
              name={
                nftActive?.item_type === 'REGENERATION_HASH_OOO_R'
                  ? `Regeneration Hash [${formatItemName(nftActive?.name)}] (#${
                      nftActive?.tokenId
                    })`
                  : nftActive?.item_type === 'Enhance_Item_Crystal'
                  ? `${t('crystalItem', {
                      item: nftActive?.name,
                    })} (#${nftActive?.tokenId})`
                  : nftActive?.item_type === 'Enhance_Item_Coach'
                  ? `${nftActive?.name} (#${nftActive?.tokenId})`
                  : `${findEnNameByItemId(
                      secret_data_json,
                      nftActive?.item_type,
                      user?.player_language,
                    )} (#${nftActive?.tokenId})`
              }
              balance={balanceOAS}
              quanlityTotal={nftActive?.quantity}
            />
            <TransactionCompletedSell
              action={{
                isModalOpen: isModalSuccessOpen,
                handleOk: handleShare,
                handleCancel: handleCancelSuccess,
              }}
              t={t}
              // name={nftActive?.name}
              name={
                nftActive?.item_type === 'REGENERATION_HASH_OOO_R'
                  ? `Regeneration Hash [${formatItemName(nftActive?.name)}] (#${
                      nftActive?.tokenId
                    })`
                  : nftActive?.item_type === 'Enhance_Item_Crystal'
                  ? `${t('crystalItem', {
                      item: nftActive?.name,
                    })} (#${nftActive?.tokenId})`
                  : nftActive?.item_type === 'Enhance_Item_Coach'
                  ? `${nftActive?.name} (#${nftActive?.tokenId})`
                  : `${findEnNameByItemId(
                      secret_data_json,
                      nftActive?.item_type,
                      user?.player_language,
                    )} (#${nftActive?.tokenId})`
              }
              store={'Marketplace'}
              txHash={txHash}
            />
            <TransactionCompletedSellShop
              action={{
                isModalOpen: isModalSuccessShopOpen,
                // handleOk: handleShare,
                handleCancel: handleCancelSuccessShop,
              }}
              t={t}
              // name={nftActive?.name}
              name={
                nftActive?.item_type === 'REGENERATION_HASH_OOO_R'
                  ? `Regeneration Hash [${formatItemName(nftActive?.name)}] (#${
                      nftActive?.tokenId
                    })`
                  : nftActive?.item_type === 'Enhance_Item_Crystal'
                  ? `${t('crystalItem', {
                      item: nftActive?.name,
                    })} (#${nftActive?.tokenId})`
                  : nftActive?.item_type === 'Enhance_Item_Coach'
                  ? `${nftActive?.name} (#${nftActive?.tokenId})`
                  : `${findEnNameByItemId(
                      secret_data_json,
                      nftActive?.item_type,
                      user?.player_language,
                    )} (#${nftActive?.tokenId})`
              }
              store={'Shop'}
              txHash={txHash}
            />
          </div>
        </Col>
      </Row>
    </BodyProfile>
  )
}
export default AssetsItems
